import { useSearchParams } from 'react-router-dom';
import * as React from 'react';
import { GridFilterItem } from '@mui/x-data-grid-premium';
import { AQDataGridQueryParams } from './AQDataGrid';

export function useDataGridUrlSync() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Helper to parse params from URL
  const getParamsFromUrl = (): AQDataGridQueryParams => {
    const parseJson = (value: string | null, defaultValue: any) => {
      try {
        return JSON.parse(value || JSON.stringify(defaultValue));
      } catch {
        return defaultValue;
      }
    };

    const pageSize = searchParams.get('pageSize');
    const page = searchParams.get('page');

    return {
      size: pageSize ? Number(pageSize) : 10,
      page: page ? Number(page) : 1,
      sort: parseJson(searchParams.get('sort'), []),
      filter: parseJson(searchParams.get('filter'), []),
      tab: searchParams.get('tab') || undefined,
    };
  };

  // Always derive queryParams from the URL
  const queryParams = getParamsFromUrl();

  // setQueryParams updates the URL only
  const setQueryParams = React.useCallback(
    (updater: (prev: AQDataGridQueryParams) => AQDataGridQueryParams) => {
      const prev = getParamsFromUrl();
      const next = updater(prev);
      const newParams = new URLSearchParams();
      newParams.set('pageSize', next?.size?.toString() || '10');
      newParams.set('page', next?.page?.toString() || '1');
      newParams.set('sort', JSON.stringify(next.sort));
      newParams.set('filter', JSON.stringify(next.filter));
      newParams.set('tab', next.tab || '');
      setSearchParams(newParams, { replace: true });
    },
    [setSearchParams, searchParams],
  );

  return {
    queryParams,
    setQueryParams,
  };
}
